module.exports = __webpack_public_path__ + "img/contract.c1e9af4e.png";